import React, { useContext, useEffect, useRef, useState } from 'react'

import {
  Alert,
  Card,
  Column,
  Columns,
  Box,
  Heading,
  Form,
  Inline,
  Button,
  Modal,
  Stack,
  Text,
  TextField
} from '@myxplor/stardust'
import CloseIcon from '../../icons/CloseIcon'
import { ignitionPost } from '~/utils/ignitionFetch'
import { isEmailValid } from '~/utils/isEmailValid'
import { TokenContext } from '../../context/TokenContext'

const getSaveUrl = (serviceId, childId, enrolmentToken) => {
  if (enrolmentToken) {
    return 'api/v1/save-enrolment-form'
  } else if (childId) {
    return `api/v1/save-enrolment-form/service/${serviceId}/child/${childId}`
  }

  return `api/v1/save-enrolment-form/service/${serviceId}`
}

const NavComponent = ({ survey, schema, serviceId, childId, isReEnrolment }) => {
  const [pagePosition, setPagePosition] = useState({ isFirst: true, isLast: false, pageNumber: 0 })
  const [isOpen, setOpen] = useState(false)
  const dataRef = useRef(null)
  const [email, setEmail] = useState('')
  const [isLoading, setLoading] = useState(false)
  const [showError, setShowError] = useState(false)
  const [errors, setErrors] = useState('')
  const [showMessage, setShowMessage] = useState(false)
  const validEmail = isEmailValid(email)
  const [token, setTokenContext] = useContext(TokenContext)

  useEffect(() => {
    survey.onCurrentPageChanged.add(surveyObj => {
      setPagePosition({
        isFirst: surveyObj.isFirstPage,
        isLast: surveyObj.isLastPage,
        pageNumber: surveyObj.currentPageNo
      })
      // Scroll to top when page changes
      window.scrollTo({ top: 0, behavior: 'smooth' })
    })
  }, [survey]) // if the survey obj updates I want to run this effect again

  useEffect(() => {
    if ((!email || email == '') && survey && survey.data) {
      setEmail(survey.data['XplorRequired_PCEmail'])
    }
  }, []) // I only want this to happen once

  useEffect(() => {
    if (isOpen) {
      dataRef.current = survey.data
    }
  }, [isOpen])

  const onSave = data => {
    const body = {
      form_data: data,
      schema: schema,
      email: email
    }
    if (validEmail) {
      setLoading(true)
      ignitionPost(getSaveUrl(serviceId, childId, token), token, body)
        .then(response => {
          if (response) {
            setTokenContext(response.data.token)
            setLoading(false)
            setShowMessage(true)
            setShowError(false)
          }
        })
        .catch(err => {
          const message = err.message || err.errors
          setLoading(false)
          setShowError(true)
          setErrors(message)
        })
    } else {
      setShowError(true)
      setErrors('Invalid email. Please try again.')
    }
  }

  const closeHandler = () => {
    survey.data = dataRef.current
    survey.currentPageNo = pagePosition.pageNumber
    setShowError(false)
    setErrors('')
    setOpen(false)
    setShowMessage(false)
  }

  return (
    <>
      <Modal isOpen={isOpen} backdrop={true} onBlur={() => closeHandler()}>
        <Card>
          <Box padding="large" width="440px">
            <Box
              color="lowEmphasis"
              padding="small"
              position="absolute"
              right={0}
              top={0}
              onClick={() => closeHandler()}
            >
              <CloseIcon />
            </Box>
            <Stack space="medium">
              <Heading level={6}>Save Enrolment Form</Heading>
              <Text color="highestEmphasis" prefab="body">
                A link will be sent to your email with the progress of your saved enrolment form.
              </Text>

              <Form onSubmit={() => {}}>
                <Stack space="medium">
                  <TextField value={email || ''} onChange={value => setEmail(value)} placeholder="Email" />
                  {errors && showError && <Alert tone="negative">{errors}</Alert>}
                  {showMessage && <Alert tone="positive">Enrolment Form successfully saved.</Alert>}
                  <Inline align="right" space="small">
                    <Button variant="outline" color="orange700" onClick={() => closeHandler()}>
                      Close
                    </Button>
                    <Button color="orange700" disabled={isLoading} onClick={() => onSave(dataRef.current)}>
                      Save
                    </Button>
                  </Inline>
                </Stack>
              </Form>
            </Stack>
          </Box>
        </Card>
      </Modal>

      <Box marginLeft="small" marginRight="small" marginBottom="small">
        <Columns>
          <Column width="fill">
            {!pagePosition.isFirst && (
              <Button color="orange700" onClick={() => survey.prevPage()}>
                Previous
              </Button>
            )}
          </Column>
          <Column width="fill">
            <Inline space="small" align="right">
              {!isReEnrolment && (
                <Button variant="outline" color="orange700" onClick={() => setOpen(true)}>
                  Save
                </Button>
              )}
              {!pagePosition.isLast && (
                <Button color="orange700" onClick={() => survey.nextPage()}>
                  Next
                </Button>
              )}
              {pagePosition.isLast && (
                <Button color="orange700" onClick={() => survey.completeLastPage()}>
                  Complete
                </Button>
              )}
            </Inline>
          </Column>
        </Columns>
      </Box>
    </>
  )
}

export default NavComponent
